import { TProduct } from "./products.type";

export type TProductSyncOriginFields = Pick<
  TProduct,
  | "product_integration_ref"
  | "infinity_sync_source_organizations"
  | "infinity_sync_as_source"
>;

/**
 * Espelho criado/atualizado pelo job sync Infinity → Soulhub (planos).
 * `product_integration_ref` sozinho não basta: muitos cadastros nativos/Infinity
 * usam ref com `infinity_sync_as_source` true (default).
 */
export function isInfinitySyncedProduct(
  product: TProductSyncOriginFields | null | undefined
): boolean {
  if (!product) return false;
  if (
    Array.isArray(product.infinity_sync_source_organizations) &&
    product.infinity_sync_source_organizations.length > 0
  ) {
    return true;
  }
  if (product.infinity_sync_as_source !== false) {
    return false;
  }
  const ref = product.product_integration_ref?.trim();
  return typeof ref === "string" && ref.length > 0;
}
